export default {
  /**
   * Obtener la ruta actual del state
   */
  getRoute: state => () => state.route,

  // Obtener el model + datos de pasos 1
  getPaso1: state => () => state.paso1,

  // Obtener el model + datos de pasos 2
  getPaso2: state => () => state.paso2,

  // Obtener el model + datos de pasos 3
  getPaso3: state => () => state.paso3,

  // Obtener el model + datos de pasos 4
  getPaso4: state => () => state.paso4,

  // Obtener el tracking code
  getTcode: state => () => state.tcode,

  getConsultarHash: state => () => {
    return {
      codigoPremio: state.paso3.seleccion,
      numeroCampania: state.paso3.numeroCampania,
      numeroClienteAltamira: state.paso3.numeroCliente
    };
  },

  getCampaniaSeleccionada: state => () => state.tipoCampaniaSeleccionada
};
